import { CloseRounded as CloseIcon } from '@mui/icons-material';
import { useFlowBuilder2PageContext } from '../../Context/useFlowBuilder2PageContext';
import { StyledIconButton } from '../../FlowBuilder2Page.styles';

export const CloseIconButton = () => {
  const { close } = useFlowBuilder2PageContext();

  return (
    <StyledIconButton size="small" onClick={close}>
      <CloseIcon fontSize="small" />
    </StyledIconButton>
  );
};
